import React from "react";
import { StyleSheet, View, ViewProps } from "react-native";

const Right = ({ ...props }: ViewProps) => {
  const preExistingStyles = props.style ?? {};
  props.style = StyleSheet.compose(preExistingStyles, styles.container);

  return <View {...props} />;
};

const styles = StyleSheet.create({
  container: {
    marginLeft: "auto",
  },
});

export default Right;
